import React from "react";
import Button from "components/CustomButtons/Button.js";
import withStyles from "@material-ui/core/styles/withStyles";
import { string, func, object } from "prop-types";
import { Grid } from "@material-ui/core";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import brandTheme from "brandTheme/Theme";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";

const BankInformationUI = ({
  inputFields,
  ifscCodeHandler,
  ifsccodeState,
  ifsccode,
  setIFSCCODE,
  setIFSCcodeState,
  classes,
  bankaccountState,
  bankaccount,
  setBankaccountState,
  setBankAccount,
  AccountValidater,
  accountDetailFileds,
  accountType,
  setAccountType,
  accountTypeState,
  setAccountTypeState,
  accountTypeList,
  editable,
  chequeNumber,
  setCheckqueNumber,
  skipChequeNumberFiled,
  hideMatchingPercentageFlag,
  disabledField,
  disabledFieldBank,
  handleInputChange,
  handleInputChangeBank,
  ifscValidate,
  isBankVerified,
  ifscValidateAttempted,
  bankVerifiedAttepmted,
  bankState,
  branchState,
  stateState,
  addressState,
  StatusState,
  beneficiaryNameState,
  matchingPercentageState,
  validateThirdPartyAttemptsFlag
}) => {
  return (
    <>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ position: "relative" }}
          >
            <CustomeTextField
              label="IFSC Code"
              required
              error={ifsccodeState}
              value={ifsccode?.toUpperCase() || ""}
              setState={setIFSCCODE}
              setError={setIFSCcodeState}
              type='notCapital'
              disabled={!editable}
              maxLength="11"
              id="ifsc_code"
              validationState={ifscValidateAttempted}
              validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
            />
           {editable && <Button
              className={`${classes.verifyButton} ${classes.nextButton3}`}
              size="small"
              onClick={() => ifscCodeHandler()}
              style={{position: "absolute",
              top: 0,
              right: 0,
              margin: 0,
              }}
            >
              Search
            </Button>}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Bank Name"
              required
              value={inputFields?.Bank || ""}
              setState={handleInputChange}
              disabled={true && disabledField}
              type="allValue"
              id="Bank"
              error={bankState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Branch"
              required
              value={inputFields?.Branch || ""}
              setState={handleInputChange}
              disabled={true && disabledField}
              type="allValue"
              id="Branch"
              error={branchState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Address"
              required
              value={inputFields?.Address || ""}
              disabled={true && disabledField}
              type="allValue"
              setState={handleInputChange}
              id="Address"
              error={addressState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="State"
              required
              value={inputFields?.State || ""}
              disabled={true && disabledField}
              type="allValue"
              setState={handleInputChange}
              id="State"
              error={stateState}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ position: "relative" }}
          >
            <CustomeTextField
              label="Bank Account"
              required
              error={bankaccountState}
              value={bankaccount || ""}
              setState={setBankAccount}
              setError={setBankaccountState}
              disabled={!editable}
              id="bank_account"
              validationState={bankVerifiedAttepmted}
              validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
            />
            { editable &&  <Button
               className={`${classes.verifyButton} ${classes.nextButton3}`}
              size="small"
              onClick={() => AccountValidater()}
              style={{position: "absolute",
              top: 0,
              right: 0,
              margin: 0,
              }}
            >
              Validate
            </Button>
          }
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Status"
              required
              value={accountDetailFileds?.Status || ""}
              disabled={true}
              setState={handleInputChangeBank}
              id="Status"
              type="allValue"
              error={StatusState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Beneficiary Name"
              required
              value={accountDetailFileds?.BeneficiaryName || ""}
              disabled={true && disabledFieldBank}
              setState={handleInputChangeBank}
              id="BeneficiaryName"
              type="allValue"
              error={beneficiaryNameState}
            />
          </Grid>
          {!hideMatchingPercentageFlag && 
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Matching Percentage"
              required
              value={accountDetailFileds?.MatchingPercentage || ""}
              disabled={true}
              id="matching_percentage"
              error={matchingPercentageState}
            />
          </Grid>
          }
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Account Type*"
              error={accountTypeState}
              value={accountType}
              setState={setAccountType}
              data={accountTypeList}
              setError={setAccountTypeState}
              disabled={!editable}
              type="type"
              id="account_type"
            />
          </Grid>
          {!skipChequeNumberFiled && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Cheque Number"
              required
              value={chequeNumber}
              setState={setCheckqueNumber}
              id="cheque_number"
              disabled={!editable}
            />
          </Grid>
          }
        </Grid>
      </Grid>
    </>
  );
};

BankInformationUI.propTypes = {
  inputFields: object,
  ifscCodeHandler: func,
  ifsccodeState: string,
  ifsccodeErrorMsg: string,
  ifsccode: string,
  change: func,
  setIFSCCODE: func,
  setIFSCcodeErrorMsg: func,
  setIFSCcodeState: func,
  classes: object,
  bankaccountState: string,
  bankaccount: string,
  setBankaccountState: func,
  bankaccountErrorMsg: func,
  setBankAccount: func,
  setBankaccountErrorMsg: func,
  AccountValidater: func,
  accountDetailFileds: object,
};
export default BankInformationUI;